import React from "react";
import PlansDisplay from "components/PlansDisplay";

const V2SubscriptionTab = () => {

  const handlePlanSelect = (plan) => {
    // Custom logic for plan selection in the profile tab
    // This can be extended with specific behavior for the profile context
    console.log('Plan selected in profile:', plan);
  };

  return (
    <div className="w-full pb-6">
      {/* Header */}
      <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl shadow-lg p-4 md:p-6 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-500/40 flex items-center justify-center backdrop-blur-md flex-shrink-0">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          </div>
          <div>
            <h3 className="text-white font-bold text-lg">Planes de Suscripción</h3>
            <p className="text-white/70 text-xs md:text-sm">Desbloquea funcionalidades avanzadas de IA para optimizar tus campañas</p>
          </div>
        </div>
      </div>

      {/* Plans Display */}
      <PlansDisplay
        onPlanSelect={handlePlanSelect}
        isModal={false}
      />
    </div>
  );
};

export default V2SubscriptionTab; 